import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getShouldShowActiveCallState, getShouldShowEndCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { getIsTabCall, getIsInboundCall, getIsOutboundCall, getHasConnectionType } from '../../remote-control/utils/widgetDetailsOperators';
import { CALLING_PREVIEW_PANEL_CALLBACK } from 'calling-internal-common/constants/CallingGates';
export const useHandleBidirectionalCallStates = gates => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const callStatus = getCallStatus(widgetDetails);
  const hasConnectionType = getHasConnectionType(widgetDetails);
  const isActiveCall = getShouldShowActiveCallState(callStatus);
  const isTabCall = getIsTabCall(widgetDetails);
  const isInboundCall = getIsInboundCall(widgetDetails);
  const isOutboundCall = getIsOutboundCall(widgetDetails);
  const isEndCallState = getShouldShowEndCallState(callStatus);
  const isActiveInbound = isActiveCall && isInboundCall;
  const isActiveOutbound = isActiveCall && isOutboundCall;
  const isActiveTabCall = isActiveCall && isTabCall;
  const isEndingTabCall = isEndCallState && isTabCall;
  const isEndingInboundCall = isInboundCall && isEndCallState;
  const isUngatedForPreviewPanelCallback = gates && gates.includes(CALLING_PREVIEW_PANEL_CALLBACK);

  /** This file contains logic for determining active call state in the remote after introducing bidirectional calling, covering a couple edge cases.
   *  The purpose of this logic is so can be backwards compatible for a new widgetDetails property `connectionType: STANDLONE_CALLING_APP | EXTERNAL`,
   *
   *  Scenarios for showing active call state:
   *  1. isActiveInbound - covers current inbound calling
   *  2. isActiveTabCall - covers users who have the new webworker property and are making outbound calls in the tab
   *  3. isUngated && !hasConnectionType && isActiveOutbound - covers users who have the stale/old webworker and make outbound calls - this will,
   *     however, show active call state in the remote for users making outbound WIDGET calls as well,
   *     which we are okay with having a small subset of users who are ungated experiencing this.
   */
  const shouldShowActiveCallState = isActiveInbound || isActiveTabCall || isUngatedForPreviewPanelCallback && !hasConnectionType && isActiveOutbound;
  const shouldShowEndCallState = isEndingInboundCall || isEndingTabCall || isUngatedForPreviewPanelCallback && !hasConnectionType && isEndCallState;
  return {
    shouldShowActiveCallState,
    shouldShowEndCallState
  };
};